/** Salesforce Text field max length (excludes Text Area / Long Text Area). */
export const SF_STRING_MAX_LENGTH = 255;
